/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2020 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2020 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { WMImageStoreLoadType } from './LoadDurationCounter';
import WMImage from './WMImage';
import { WMImageEventType } from './WMImageStore';
import { wmDetermineDimensionMode } from './WMJSDimensionModes';
import {
  isDefined,
  toArray,
  debugLogger,
  DebugType,
  getUriWithParam,
  getMapDimURL,
} from './WMJSTools';
import { LayerType } from './WMLayerTypes';
import { getLegendGraphicURLForLayer, legendImageStore } from './WMLegend';
import WMListener from './WMListener';
import WMProjection from './WMProjection';
import {
  parseISO8601DateToDate,
  DateInterval,
  parseISO8601IntervalToDateInterval,
  ParseISOTimeRangeDuration,
} from './WMTime';
import { WMXMLStringToJson } from './WMXMLParser';

export {
  default as WMJSDimension,
  handleDateUtilsISOString,
} from './WMJSDimension';

export { default as WMLayer } from './WMLayer';
export type {
  LayerOptions,
  LayerFoundation,
  EDRFeatureLayerOptions,
} from './WMLayerTypes';
export { LayerType };
export { default as WMBBOX } from './WMBBOX';
export type { Bbox } from './WMBBOX';
export type { WMProjectionWH } from './WMProjection';
export { WMProjection };
export {
  DateInterval,
  parseISO8601IntervalToDateInterval,
  ParseISOTimeRangeDuration,
  isDefined,
  parseISO8601DateToDate,
  toArray,
  getLegendGraphicURLForLayer,
  legendImageStore,
  WMImage,
  debugLogger,
  DebugType,
  WMImageEventType,
  getUriWithParam,
  getMapDimURL,
  WMListener,
  WMXMLStringToJson,
  WMImageStoreLoadType,
  wmDetermineDimensionMode,
};

export type * from './types';
export type * from './WMTimeTypes';
export * from './WMConstants';

const wmServiceListener = new WMListener();
export { wmServiceListener };
